var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-display",class:[_vm.color, { clickable: _vm.clickable }]},[_c('span',[_vm._t("default",[_vm._v(_vm._s(_vm.tagText))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }